import { TranslationService } from "@/core/services/TranslationService";
import EventManagementForm from "@/views/eventManagement/views/EventManagementForm.vue";
import EventDetail from "@/views/eventManagement/views/EventDetail.vue";
import { boolean } from "yup";

export function eventManagementTableHeaders() {
  return [
    {
      name: TranslationService.translate("pages.event.title"),
      key: "eventName",
      sortable: true,
    },
    {
      name: TranslationService.translate("pages.event.eventType"),
      key: "eventSubType",
      sortable: true,
    },
    {
      name: TranslationService.translate("common.startDate"),
      key: "startDate",
      sortable: true,
    },
    {
      name: TranslationService.translate("common.endDate"),
      key: "endDate",
      sortable: true,
    },
    {
      name: TranslationService.translate("common.createdBy"),
      key: "createdBy",
    },
    {
      name: TranslationService.translate("common.status"),
      key: "status",
    },
    {
      name: TranslationService.translate("common.actions"),
      key: "actions",
      attrs: {
        class: "vz-dataTable-center",
      },
    },
  ];
}

function formatText(text: string) {
  return text
    .toLowerCase() // Convert to lowercase
    .replace(/_/g, " ") // Replace underscores with spaces
    .replace(/\b\w/g, (c) => c.toUpperCase()); // Capitalize the first letter of each word
}

export function eventManagementTableFilters() {
  return [
    {
      key: "filterEventIds",
      label: TranslationService.translate("common.events"),
      type: "lookup",
      attrs: {
        mode: "tags",
      },
      url: "notification/filter/EVENTS",
      textKey: "text",
      valueKey: "value",
    },
    {
      key: "subType",
      label: TranslationService.translate("common.types"),
      type: "lookup",
      attrs: {
        mode: "tags",
      },
      url: "notification/filter/EMAIL_EVENT_CONFIG?siteIds=",
      textKey: "text",
      valueKey: "value",
    },
    {
      key: "startDate",
      label: TranslationService.translate("common.dateRange"),
      type: "datetimerange",
    },
    {
      key: "status",
      label: TranslationService.translate("common.status"),
      type: "select",
      options: [
        { label: TranslationService.translate("common.all"), value: "" },
        {
          label: TranslationService.translate("common.active"),
          value: "ACTIVE",
        },
        {
          label: TranslationService.translate("common.inactive"),
          value: "INACTIVE",
        },
      ],
    },
  ];
}

export function eventManagementTableBulkDelete() {
  return {
    showDelete: true,
    key: "webId",
    entity: "events",
    entityLabel: TranslationService.translate("pages.event.bulkDelete"),
  };
}

export function EVENTMANAGEMENT_TABS() {
  return [
    {
      title: TranslationService.translate("common.detail"),
      name: "event.detail",
      icon: "bi bi-card-text me-2 fs-4 text-primary",
      component: EventDetail,
      props: {
        data: {},
      },
    },
    {
      title: TranslationService.translate("common.forms"),
      name: "event.form",
      icon: "bi bi-layers fs-1 me-2 text-primary align-middle mb-1",
      component: EventManagementForm,
      props: {
        data: {},
        openDrawer: boolean,
      },
    },
  ];
}

export function EventManagementFormTableHeaders() {
  return [
    {
      name: TranslationService.translate("common.formName"),
      key: "name",
      sortable: true,
    },
    {
      name: TranslationService.translate("common.assignedDate"),
      key: "assignDate",
      sortable: true,
    },
    {
      name: TranslationService.translate("common.status"),
      key: "status",
    },
    // {
    //   name: TranslationService.translate("common.actions"),
    //   key: "actions",
    //   attrs: {
    //     class: "vz-dataTable-center",
    //   },
    // },
  ];
}

export function EventManagementFormTableFilters() {
  return [
    {
      key: "formDefinitionIds",
      label: TranslationService.translate("common.forms"),
      type: "lookup",
      attrs: {
        mode: "tags",
      },
      url: "forms/filter/FORM_NAME",
      textKey: "text",
      valueKey: "value",
    },
    {
      key: "status",
      label: TranslationService.translate("common.status"),
      type: "select",
      options: [
        { label: TranslationService.translate("common.all"), value: "" },
        {
          label: TranslationService.translate("common.active"),
          value: "ACTIVE",
        },
        {
          label: TranslationService.translate("common.inactive"),
          value: "INACTIVE",
        },
      ],
    },
  ];
}

export function EventManagementFormTableBulkDelete() {
  return {
    showDelete: true,
    key: "webId",
    entity: "lookupsData",
    entityLabel: TranslationService.translate("common.forms"),
  };
}

export const EVENT_MANAGEMENT_FORM_LOOKUP = {
  url: "forms/filter/FORM_NAME",
  textKey: "text",
  valueKey: "value",
};
